<template>
  <div class="container">
    <div class="body">
      <h2>植萌小店商家端</h2>
      <el-form ref="form" :model="form" label-width="40px">
        <el-form-item label="账号">
          <el-input v-model="form.username"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="form.password"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" style="padding: 12px 90px; background-color: #009245; border-color: #009245;">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "MerchantLogin",
  data() {
    return {
      form: {
        username: "",
        password: "",
      },
    };
  },
  created() {},
  mounted() {},
  methods: {
    async onSubmit() {
      try {
        const response = await this.$http.post(
          "/api/merchantLogin",
          this.form
        );
        // console.log(response);
        // 如果请求成功（status code 2xx）
        const { token, merchantInfo } = response.data;
        this.$message({
          message: "登录成功",
          type: "success",
          duration: 2000, // 持续时间，单位为毫秒，默认值是3000
          showClose: true, // 显示关闭按钮，默认是false
        });
        localStorage.setItem("token", token);
        localStorage.setItem("merchantInfo", JSON.stringify(merchantInfo));
        this.$router.push("/Manage");
      } catch (error) {
        console.error("Error:", error);

        // 检查是否有响应对象存在
        if (error.response) {
          // 请求已发出且服务器也响应了状态码，但状态码超出了 2xx 的范围
          if (error.response.status === 403) {
            this.$message({
              message: "账号或密码错误，请重试。",
              type: "error",
              duration: 2000,
              showClose: true,
            });
          } else {
            // 其他非2xx状态码的处理
            this.$message({
              message: "服务器错误，请稍后再试。",
              type: "error",
              duration: 2000,
              showClose: true,
            });
          }
        } else if (error.request) {
          // 请求已发出但没有收到响应
          this.$message({
            message: "请求失败，请检查网络连接。",
            type: "error",
            duration: 2000,
            showClose: true,
          });
        } else {
          // 发送请求时发生了一些其他错误
          this.$message({
            message: "请求配置错误，请检查配置。",
            type: "error",
            duration: 2000,
            showClose: true,
          });
        }
      }
    },
  },
};
</script>

<style scoped>
.container {
  height: 100vh;
  width: 100vw;
  background-color: #009245;
}
.body {
  background-color: #f3f3f3;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 10px;
  padding: 30px 50px;
}
</style>